import useSWRImmutable from 'swr/immutable';

import type { PublicSettingsDto } from '@dto/PublicSettings.dto';
import { getAPIFetcher } from '@isomorphic/swr-fetchers';

export const usePublicRuntimeSettings = (): {
  isLoading: boolean;
  isError?: string;
  publicRuntimeSettings: PublicSettingsDto;
} => {
  const { data, error, isLoading } = useSWRImmutable<PublicSettingsDto>('/docs/api/public-settings', getAPIFetcher, {
    errorRetryCount: 1,
  });

  return {
    publicRuntimeSettings: data || {
      epicAccountPortalBaseUrl: '',
      epicAccountPortalBasePath: '',
      epicServiceClientId: '',
      assetsUrl: '',
      marketingUrl: '',
    },
    isLoading,
    isError: error,
  };
};
